module.exports = __webpack_public_path__ + "media/images/arrow-right-white-48ba7ddf02e9e57d30fbd63dac408929.svg";